import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect, useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import OperationalAction from 'components/Operational/operationalAction';
import { findTask } from 'utils/helper/task';
import { getError, getLoadingState } from 'reducers/ui';
import { TASK_STATUS, UN_ASSIGNABLE_TASK_STATUS } from 'utils/constants/task';
import API from 'services/api';
import { serviceTypes } from 'utils/constants/serviceTypes';
import { getSecurityCompanyId } from 'reducers/securityCompany';
import {
  securitySelectors,
  securityTaskPageActions,
} from 'containers/Pages/Tasks/Security';
import { transformBasicPersonnel } from 'utils/DataTransform/Personnel/PersonnelList';
import { PAGE_URLS } from 'utils/constants';
import PerformTask from '../Generic/OperationalComponents/PerformTasks/performTask';

const styles = {
  root: {
    width: '100%',
  },
  actionButton: {
    padding: '4px 10px',
  },
};

const TaskOperational = ({
  classes,
  id,
  onChange,
  details,
  selected,
  securityCompanyId,
  completedEvidences,
  defaultValues,
}) => {
  const [selectedTaskAssignee, setAssignee] = useState();
  const [taskWindow, setTaskWindow] = useState(false);
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    if (!isEmpty(selectedTaskAssignee)) {
      onChange({ id, value: selectedTaskAssignee, task: details, selected });
    }
  };

  const canEditTask = () => {
    const task = findTask({ tasks: details, id });
    return (
      task && UN_ASSIGNABLE_TASK_STATUS.some(item => task.status.includes(item))
    );
  };

  useEffect(() => {
    setAssignee();
    if (
      !isEmpty(selected) &&
      selected.assignee !== null &&
      selected.assignee !== '-'
    ) {
      const task = findTask({ tasks: details, id });
      if (task) {
        setAssignee({
          id: task.assigneeId,
          name: task.assigneeFullName,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details, id]);

  const selectedTask = details?.tasks?.find(
    task => task.id === details.rootTaskId,
  );
  const clickOpenTaskWindow = () => {
    setTaskWindow(true);
  };
  const getActionItem = type => {
    switch (type) {
      case 'assign-security':
        return {
          label: 'Assign Personnel',
          placeholder: 'Assign personnel',
          selectedValue: selectedTaskAssignee,
          changeSelectedValue: setAssignee,
          btnText: 'Assign',
          btnSize: 's',
          btnColor: 'primary',
          btnClick: handleButtonClick,
          btnDisabled: canEditTask(),
          fetchOptions: API.fetchUserList,
          dataTransform: ({ data }) => {
            return transformBasicPersonnel(data);
          },
          fetchFilters: {
            securityCompanyId,
            archived: false,
            service: [serviceTypes.security],
            ...(selectedTask?.site?.id && { siteId: selectedTask.site.id }),
          },
          optionLabelKey: 'name',
        };
      case 'performTaskForm':
        return {
          btnText: 'Perform task',
          btnSize: 'xl',
          btnColor: 'primary',
          btnClickHandler: clickOpenTaskWindow,
          alignment: 'left',
        };

      default:
        return null;
    }
  };
  const enablePerformTask = useCallback(() => {
    return (
      !isEmpty(details) &&
      (details.tasks[0].status === TASK_STATUS.IN_PROGRESS.id ||
        details.tasks[0].status === TASK_STATUS.NEW.id)
    );
  }, [details]);
  const endTaskHandler = ({ data }) => {
    dispatch(securityTaskPageActions.endTask({ data }));
  };

  const startTaskHandler = ({ data }) => {
    dispatch(securityTaskPageActions.startTask({ data }));
  };
  return (
    <div className={classes.root}>
      {enablePerformTask() && (
        <OperationalAction
          type={'button'}
          item={getActionItem('performTaskForm')}
        />
      )}
      {taskWindow && (
        <PerformTask
          serviceType={serviceTypes.security}
          taskDetails={details}
          completedEvidences={completedEvidences}
          id={id}
          defaultValues={defaultValues}
          closeForm={() => {
            setTaskWindow(false);
          }}
          view={PAGE_URLS.SECURITY_TASKS.link}
          startTaskHandler={startTaskHandler}
          endTaskHandler={endTaskHandler}
        />
      )}
      <OperationalAction
        type={'asyncDropdown'}
        item={getActionItem('assign-security')}
      />
    </div>
  );
};

TaskOperational.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string,
  details: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  selected: PropTypes.object,
  setMessage: PropTypes.func,
  toggleModal: PropTypes.func,
  toggleEditMode: PropTypes.func,
  securityCompanyId: PropTypes.string,
  completedEvidences: PropTypes.array,
  defaultValues: PropTypes.object,
};

const mapStateToProps = state => ({
  error: getError(state),
  loading: getLoadingState(state),
  details: securitySelectors.getRowDetailsUnTransformed(state),
  completedEvidences: securitySelectors.getCompletedEvidences(state),
  securityCompanyId: getSecurityCompanyId(state),
});

export default connect(mapStateToProps)(withStyles(styles)(TaskOperational));
